import { loadFile } from "common/FileInput";

export function doFileChange(
  file,
  ifCl,
  handleSucces,
  handleErrorNoFile,
  handleErrorSave
) {
  if (file) {
    const remotePath = `/tmp/lic_${Math.random().toString(36).substring(5)}`;
    loadFile(file)
      .then((response) => {
        ifCl.saveAsFile(response, remotePath, (res) =>
          handleSucces(res, remotePath, file.name)
        );
      })
      .catch(handleErrorSave);
  } else {
    handleErrorNoFile();
  }
}

export const handleSaveFile = (response, remotePath) => {
  if (response.SaveAsFileResponse.code !== 0) {
    showModalError("Error saving file", response.SaveAsFileResponse.reason);
  } else {
    ifCl
      .run(`set license load ${remotePath}`)
      .then((response) => {
        if (response === "") {
          window.location.reload();
        } else {
          showModalError(
            "Error loading license",
            response.CmdResponse.response
          );
        }
      })
      .catch((error) => {
        showModalError("Error loading license", error);
      });
  }
};

export const handleFileChange = (event) => {
  const [file] = event.target.files;
  doFileChange(
    file,
    ifCl,
    handleSaveFile,
    showModalError("Select the license."),
    (error) => {
      showModalError("Error loading license", error);
    }
  );
};
